export default {
  logging: 'Protokollierung ...',
  logCall: 'Anruf protokollieren',
  editLog: 'Protokoll bearbeiten',
  select: 'Übereinstimmenden Datensatz auswählen',
  OnHold: 'Wird gehalten',
  Ringing: 'Es wird angerufen',
  CallConnected: 'Anruf verbunden',
  unknownUser: 'Unbekannter Benutzer',
  unknownNumber: 'Anonym',
  unavailable: 'Nicht verfügbar',
  viewDetails: 'Details anzeigen',
  'phoneSource.systemUser': '(Systembenutzer)',
  'phoneSource.account': '(Konto)',
  'phoneSource.contact': '(Kontakt)',
  'phoneSource.lead': '(Lead)',
  'phoneType.phone': '(Telefon)',
  'phoneType.home': '(Telefon (privat))',
  'phoneType.business': '(Telefon (geschäftlich))',
  'phoneType.mobile': '(Mobiltelefon)',
  'phoneType.unknown': '(Unbekannter Telefontyp)',
};
